import { Input, Header, Button, Loader } from "@scuf/common";
import { useEffect, useState } from "react";
import { useAuth } from "../../hooks/useAuth";
import servicesAuth from "../../services/auth.services";
import { useHistory } from "react-router-dom";
// Parte para la importacion de logos
import backgroundDMH from "../../img/dmh-tostacion.png";
import logoCodelco from "../../img/logo-codelco.svg";

import "./login-lindo.css";
// Estilos para las notificaciones
import "react-toastify/dist/ReactToastify.css";
// Traemos los efectos para hacer notificaciones
import { toast } from "react-toastify";
import FooterToast from "../../components/footer/FooterToast";

/**
 * Funcion que retorna el login de la aplicación
 * @returns
 */
export default function LoginLindo() {
  // Expresión regular para validar que solo sean caracteres
  const onlyCharactersRegex = /^[a-zA-ZÀ-ÿ]+$/;
  // Creamos objeto para poder navegar
  const history = useHistory();
  // Pantalla general de carga del login
  const [showLoadingScreen, setShowLoadingScreen] = useState(true);
  // Estados de carga de la aplicación
  const [loading, setLoading] = useState(false);
  // useState para el usuario y contraseña
  const [user, setUser] = useState("");
  const [password, setPassword] = useState("");

  const { loginHook } = useAuth();

  // Objeto de validaciones, aca las instaciamos y creamos
  const objtValidaciones = {
    user: user.trim() ? undefined : "Campo requerido",
    password: password.trim() ? undefined : "Campo requerido",
    onlyCharactersUserName: onlyCharactersRegex.test(user.trim())
      ? undefined
      : "Solo puede ingresar caracteres en este campo",
  };

  // Hook que manipulara las validaciones
  const [validation, setValidation] = useState(objtValidaciones);

  /**
   * Funcion que valida los campos de formulario
   * @returns
   */
  function validate() {
    return objtValidaciones;
  }

  /**
   * Ejecutamos la comprobacion del formulario
   * este hook se ejecutara cada vez que el formulario cambie
   */
  useEffect(() => {
    setValidation(validate);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user, password]);

  /**
   * Notificación de error en el usuario o contraseña
   * @param {*} message - string
   */
  function notify(message) {
    toast.error(message, { toastId: "login-error" });
  }

  /**
   * Función que realiza el login
   */
  async function Login() {
    setLoading(true);
    await servicesAuth
      .login(user, password)
      .then((response) => {
        // Preguntamos si existe algun error
        if (response.error) {
          setLoading(true);
          // Mandamos mensaje de error
          notify("Usuario o contraseña incorrectas, intente denuevo por favor");

          // Detenemos la ejecución
          return;
        } else {
          loginHook();
          // Redireccionamos a la pagina de inicio
          history.push("/estrategico");
        }
      })
      .catch((error) => {
        // Mandamos mensaje de error
        notify(error);
      })
      .finally(() => {
        // En cualquier cosa, cancelamos la carga del boton
        setTimeout(() => {
          setLoading(false);
        }, 3000);
      });
  }

  // Efecto que retrasa la carga del DOM para esperar que se carguen las imagenes
  useEffect(() => {
    // Realizamos la primera carga con ninguna validación, esto es para que no aparezcan mensajes sin hacer nada por parte del usuario
    setValidation({});
    setTimeout(() => {
      setShowLoadingScreen(false);
    }, 1500);
  }, []);

  // Muestra la pantalla de carga
  if (showLoadingScreen) {
    return (
      <>
        <Loader minHeight={400} text="Cargando"></Loader>
      </>
    );
  }

  return (
    <>
      <section className="login-container">
        <img
          className="background-login"
          src={backgroundDMH}
          alt="background-dmh"
        ></img>
        <div className="form-login--container">
          <Header
            className="header-login"
            isForge={true}
            menu={false}
            responsive={false}
            title={
              <>
                DIVISIÓN MINISTRO HALES
                <p>COMPLEJO TOSTACIÓN</p>
              </>
            }
          >
            <img
              id="img-logo--codelco"
              src={logoCodelco}
              alt="logo-codelco"
            ></img>
          </Header>

          <div className="inputs-container">
            <Input
              id="user-login"
              placeholder="Usuario"
              label="Usuario"
              type="text"
              value={user}
              onChange={(value) => setUser(value)}
              error={validation.user || validation.onlyCharactersUserName}
            />
            <Input
              id="input-login"
              placeholder="Contraseña"
              label="Contraseña"
              type="password"
              value={password}
              onChange={(value) => setPassword(value)}
              error={validation.password}
            />

            <Button
              id="btn-codelco"
              loading={loading}
              active={true}
              onClick={Login}
              disabled={
                (validation.onlyCharactersUserName ||
                  validation.user ||
                  validation.password) !== undefined || loading
              }
            >
              Iniciar Sesión
            </Button>
          </div>

          <FooterToast className={"footer-login"} />
        </div>
      </section>
    </>
  );
}
